import React, {useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import Xligo from '../../Classes/Connection'

export const getIndice =  async (id, type) => {    
    return await Xligo.get(`${type}/${id}/outline`)
}

const Indice = props => {
    
    const [content, setContent] = useState(null)

    const [loadmore, setLoadmore] = useState(false)

    const [type, setType] = useState( props.type === 'x' ? 'libro': props.type)
    
    useEffect(() => {
        if( props.bookId ){
            setLoadmore(true)
            getIndice(props.bookId, type)
            .then(response => response.json())
            .then(data => {
                setContent(data.outline)
                setLoadmore(false)
            })
            .catch(error => console.log(error))
        }
    }, [props.bookId, type])

    return (
        <div className="book-index">
            <header className="book-index-header">
                <FontAwesomeIcon className="book-index-header__icon" icon={props.icon} />
                    <div className="book-index-header__title">{props.title}</div>
                <FontAwesomeIcon className="book-index-header__icon book-index-header__icon--close" icon={faTimesCircle} onClick={props.display} />
            </header>
            <div className="book-index__contents">
                <div className="book-index__scroll-container">
                    <div className="book-index__items">
                        {loadmore
                            ? <div className="book-index__preload">Caricamento in corso...</div>
                            : <div className="book-index__list" dangerouslySetInnerHTML={{__html:content}}></div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Indice